/* eslint-disable-next-line import/no-unresolved */
import { useMemo } from 'react';
import { getServiceName } from '../utils';

export const useServiceName = (serviceId) => {
  return useMemo(() => getServiceName(serviceId), [serviceId]);
};
